<template>
  <div class="index" v-cloak style="background-color: #f7f7f7;">

     <div class="mask2" @click.stop="showToast = false" v-if="showToast "></div>
        <div class="lottery-alert" style="background: none;" v-if="showToast">
            <!-- <h1>恭喜您</h1> -->
            <div @click="setShowToast">
              <img style="width: 100%;height: auto !important;" src="https://dreame.dev.xunyounet.com/1747f254-0a95-46ee-9c3b-ede23bfb9434.png" alt="">
            </div>
            <!-- <h2>获得</h2> -->
            <!-- <div class="btnsave" >好的</div> -->
      </div>


    <div class="home-top">
      <div style="height: 50px;">

      </div>
      <div class="search-wrap">
        <van-search v-model="value" background="" shape="round" input-align="center" readonly @click="goSearch"
          placeholder="搜索你想要的优质商品" />
      </div>
      <div class="swipe-wrap" style="margin-top: 10px;">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="item in homeBanner" :key="item.id">
            <div class="zm_product_item" style="height: 3.2rem;">
              <router-link :to="{ path: item.wap_url }">
                <img :src="item.pic" style="height: 100%;" />
              </router-link>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="shopping-info width92">
      <div class="shopping-info-list" v-for="item in shoppingInfo">
        <div class="shopping-info-img">
          <img :src="item.icon" alt="">
        </div>
        <div class="shopping-info-title">{{ item.title }}</div>
      </div>
    </div>
    <div class="home-nav width92" v-if="menus.length">
      <div class="home-nav-box" v-for="(item, index) in menus" @click="goPages(index)">
        <div class="home-nav-box-img">
          <img :src="item.pic" alt="">
        </div>
        <div class="home-nav-box-title">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="home-card1 width92">
      <div class="home-card1-left">
        <router-link :to="{ path: `goods_list?id=39&title=家用版` }">
          <div class="home-card1-img">
            <img src="../../assets/img/home-box4-left.png" alt="">
          </div>
          <!-- <div class="home-card1-word">
            <h4>新品上市</h4>
            <p>随机有惊喜</p>
            <button>立即抢购</button>
          </div> -->
        </router-link>
      </div>
      <!-- https://dreame.dev.xunyounet.com/goods_list?id=38&title=%E4%B8%93%E4%B8%9A%E7%89%88 -->
      <div class="home-card1-right">
        <router-link :to="{ path: `/goods_list?id=38&title=专业版` }">
          <div class="home-card1-img">
            <img src="../../assets/img/home-box4-right.png" alt="">
          </div>
          <!-- <div class="home-card1-word">
            <h4>独家专享</h4>
            <p>随机有惊喜</p>
            <button>立即抢购</button>
          </div> -->
        </router-link>
      </div>
    </div>
    <div class="fitting home-card2 width92">
      <router-link :to="{ path: subBanner.wap_url }">
        <img :src="subBanner.pic" />
      </router-link>
    </div>
    <div class="width92 home-page-title">
      <div class="home-page-title-left">
        <div class="page-title">爆款推荐</div>
        <div class="page-size">百款好物 任你挑选</div>
      </div>
      <p>
        <router-link :to="{ path: `/home_product_list?id=7&title=爆款推荐` }">更多</router-link>
      </p>
    </div>

    <div class="product-scroll">
      <div class="item" v-for="(item, index) in RecommendList" :key="index">
        <div class="img">
          <img :src="item.image">
        </div>
        <div class="title line1">{{ item.store_name }}</div>
        <div class="price">
          <div class="num">￥{{ item.price }}</div>
        </div>
        <router-link :to="{ path: '/detail/' + item.id }" class="btn">
          <p class="p1">去购买</p>
          <p class="p2">></p>
        </router-link>
      </div>
    </div>


    <!-- <div  v-if=" userInfo && userInfo.is_agent == 1 && userInfo.is_promoter==1 ">
      <div class="title-index"  >
      <div class="title-index-wrap">
        <div class="zh">代理商品</div>
        <div class="en">Proxy Goods</div>
      </div>
    </div>
    <div class="product-scroll" >
      <div 
        class="item"
        v-for="(item,index) in productList4"
        :key="index"
        >
        <div class="img">
          <img :src="item.image">
        </div>
        <div class="title line1">{{item.store_name}}</div>
        <div class="price">
          <div class="name">活动价</div>
          <div class="num">￥{{item.price}}</div>
        </div>
        <router-link :to="{path: '/proxyDetail/'+ item.id}" class="btn">去购买</router-link>
      </div>
    </div>
    <router-link  :to="{path:'/agent_list' }" class="index-more fitting-more">
      <span class="text">更多</span>
      <span class="iconfont icon-jiantou"></span>
    </router-link>
     </div> -->



    <div class="home-box6">
      <div class="width92 home-box6-container">
        <div class="home-page-title">
          <div class="home-page-title-left">
            <div class="page-title">新品上市</div>
            <div class="page-size">新品上市 欢迎选购</div>
          </div>
          <p>
            <router-link :to="{ path: `/home_product_list?id=5&title=新品上市` }">更多</router-link>
          </p>
        </div>
        <div class="home-box6-bottom">
          <div class="home-box6-card" v-for="(item, index) in newProductList">
            <router-link :to="{ path: '/detail/' + item.id }">
              <div class="home-box6-card-img">
                <img :src="item.image" alt="">
              </div>
              <div class="home-box6-card-info">
                <div class="home-box6-card-title line1">{{ item.store_name }}</div>
                <div class="home-box6-card-num1">￥{{ item.ot_price }}</div>
                <div class="home-box6-card-num2">￥{{ item.price }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="home-box7">
      <div class="width92 home-box7-container">
        <div class="home-page-title">
          <div class="home-page-title-left">
            <div class="page-title">精选特惠</div>
            <div class="page-size">百款好物 任你挑选</div>
          </div>
          <p>
            <router-link :to="{ path: `/home_product_list?id=8&title=精选特惠` }">更多</router-link>
          </p>
        </div>
        <div class="home-box7-bom">
          <div class="home-box7-card" v-for="(item, index) in featuredList">
            <router-link :to="{ path: '/detail/' + item.id }">
              <div class="home-box7-card-img">
                <img :src="item.image" alt="">
              </div>
              <div class="home-box7-card-info">
                <div class="title">{{ item.store_name }}</div>
                <div class="num">￥{{ item.price }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>


    <div class="advertise">
      <img src="../../assets/images/banner-hengfu.png" />
    </div>
    <div class="home-box7">



      <div class="width92 home-box7-container">
        <div class="home-page-title">
          <div class="home-page-title-left">
            <div class="page-title">限时抢购</div>
            <div class="page-size">超低价格 史无前例</div>
          </div>
          <p>
            <router-link :to="{ path: `/home_product_list?id=9&title=限时抢购` }">更多</router-link>
          </p>
        </div>



        <!-- <div class="home-box8-container">
        <div class="home-page-title width92">
          <div class="home-page-title-left">
            <div class="page-title">限时抢购</div>
            <div class="page-size">超低价格 史无前例</div>
          </div>
          <p>
            <router-link :to="{ path: `/home_product_list?id=9&title=限时抢购` }">更多</router-link>
          </p>
        </div> -->


        <div class="home-box7-bom">
          <div class="home-box7-card" v-for="(item, index) in seckillList">
            <router-link :to="{ path: '/detail/' + item.id }">
              <div class="home-box7-card-img">
                <img :src="item.image" alt="">
              </div>
              <div class="home-box7-card-info" style="padding: .1rem .2rem;">
                <div class="title">{{ item.store_name }}</div>
                <div class="home-box8-card-num1">￥{{ item.ot_price }}</div>
                <div class="home-box8-card-num2">￥{{ item.price }}</div>
              </div>
            </router-link>
          </div>
        </div>

        <!-- <div class="home-box8-bom">
          <div class="home-box8-card" v-for="(item, index) in seckillList">
            <router-link :to="{ path: '/detail/' + item.id }">
              <div class="home-box8-card-img">
                <img :src="item.image" alt="" />
              </div>
              <div class="home-box8-card-info">
                <div class="home-box8-card-title">{{ item.store_name }}</div>
                <div class="home-box8-card-num1">￥{{ item.ot_price }}</div>
                <div class="home-box8-card-num2">￥{{ item.price }}</div>
              </div>
            </router-link>
          </div>
        </div> -->




      </div>
    </div>
    <div class="bottom-safe"></div>
    <div class="safe-padding"></div>
    <div>
      <iframe v-if="mapKey && !isWeixin" ref="geoPage" width="0" height="0" frameborder="0" scrolling="no" :src="'https://apis.map.qq.com/tools/geolocation?key=' +
        mapKey +
        '&referer=myapp'
        ">
      </iframe>
    </div>
    <GeneralWindow :generalActive="generalActive" @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"></GeneralWindow>

    <!-- <MemberWindow :showWindow="showWindow" :couponsList="couponsList" @closeMemberWindow="closeMemberWindow"></MemberWindow> -->
  </div>
</template>

<script>
  import "@assets/css/lottery.css";
import "@assets/css/swiper.min.css";
import { getUser  , getCouponsUser } from "@api/user";
import { getHomeData, getShare, follow, getHomeBanner, getH5HomeBanner } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation, wechatEvevt } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";
import { getProductDetail, getProducts, getGroomList, getAgentProducts } from "@api/store";
import Search from 'vant/lib/search'
import 'vant/lib/search/style'
import Swipe from 'vant/lib/swipe'
import 'vant/lib/swipe/style'
import SwipeItem from 'vant/lib/swipe-item'
import 'vant/lib/swipe-item/style'
import { getUserInfo } from "@api/user";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
import GeneralWindow from "@components/GeneralWindow";
import MemberWindow from "@components/MemberWindow";
export default {
  name: "Index",
  props: {},
  data: function () {
    return {
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showToast:true,
      showCoupon: false,
      logoUrl: "",
      subBanner: {},
      menus: [],
      roll: [], 
      couponsList:[], 
      showWindow: true,
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      mapKey: "",
      productid: '',
      storeInfo: {},

      productList3: [],  //配件
      productList4: [], //代理
      homeBanner: [],  //首页banner
      shoppingInfo: [ //商城提示信息
        { icon: require('@assets/img/home-hoor-icon.png'), title: '官方商城' },
        { icon: require('@assets/img/home-zan-icon.png'), title: '正品保证' },
        { icon: require('@assets/img/home-goods-icon.png'), title: '顺丰包邮' }
      ],
      // 导航栏-推广中心
      userInfo: {},
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      recommendList: [], //爆款推荐
      newProductList: [],  //新品上市
      featuredList: [], //精选特惠
      seckillList: [], //限时抢购
      homeShareInfo: {}
    };
  },
  components: {
    [Search.name]: Search,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    GeneralWindow ,
    MemberWindow
  },
  created() {
    this.getRecommendList();
    this.getNewProductList();
    this.getFeaturedList();
    this.getSeckillList();
  },
  activated() {
    getShare().then(res => {
      this.homeShareInfo = res.data.data;
      this.setOpenShare();
    })
  },
  mounted: function () {

    
    let that = this;
    this.User(); //处理跳转推广中心做判断
    that.getProducts()
    that.getAgentProductsList()
    that.getHomeBanner() 
     
    that.getUseCoupons()
    getHomeData().then(res => {
      that.mapKey = res.data.tengxun_map_key;
      cookie.set(MAPKEY, that.mapKey);
      that.logoUrl = res.data.logoUrl;
      // subBanner 副banner
      that.$set(that, "subBanner", res.data.subBanner[0]);
      that.$set(that, "menus", res.data.menus);
      console.log('menus-------------------', that.menus);
      that.$set(that, "roll", res.data.roll);
      that.$set(that, "activity", res.data.activity);
      if (res.data.activity.length) {
        var activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
      }



      that.$set(that, "info", res.data.info);
      that.$set(that, "likeInfo", res.data.likeInfo);
      that.$set(that, "lovely", res.data.lovely.length ? res.data.lovely[0] : {});
      that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.subscribe = res.data.subscribe;
      if (!that.subscribe && that.followUrl) {
        setTimeout(function () {
          that.followHid = true;
        }, 200);
      } else {
        that.followHid = false;
      }
      if (res.data.site_name) document.title = res.data.site_name;
      this.showCoupon =
        !cookie.has(HAS_COUPON_WINDOW) &&
        res.data.couponList.some(coupon => coupon.is_use);


      // 2020.10.28  分享追加
      // 携带商品id信息分享目的不清楚？
      // let productid = res.data.likeInfo[res.data.likeInfo.length - 1].id
      // getProductDetail(productid).then(res => {
      //   that.$set(that, "storeInfo", res.data.storeInfo);
      //   that.setOpenShare();
      // });
      getShare().then(res => {
        this.homeShareInfo = res.data.data;

        that.setOpenShare();
      })
    });


  },
  methods: {
    setShowToast(){
        this.showToast = false; 


        if(this.couponsList.length > 0){
          this.goSearch()
         
        }else {
            this.$router.push({
            path: '/activity/lottery'
           })
        }

        // this.goSearch()
    },
    /**
    * 获取代理商品
    */
    getAgentProductsList() {
      let params = {
        page: 1,
        limit: 8,

        priceOrder: '',
        salesOrder: ''
      }
      getAgentProducts(params).then(res => {
        // alert(`1`)
        this.productList4 = res.data
      }).catch(err => {
        this.$dialog.error(err.msg);
      })
    },
    /**
     * 追风者分享信息
    */

    /**
    * 追风者-导航栏跳转
    */
    goPages: function (index) {
      let url = this.menus[index].wap_url;
      if (url === "/user/user_promotion") {
        if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
        if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
          return (this.generalActive = true);
        }
      }
      this.$router.push({ path: this.menus[index].wap_url });
    },
    /**
     * 追风者-获取用户信息
     */
    User: function () {
      let that = this;
      getUser().then(res => {
        console.log(res)
        that.userInfo = res.data;
        if (res.data.promoter_price <= 0) {
          this.generalContent = {
            promoterNum: `请您耐心等待审核`,
            title: "您未获得推广权限"
          };
        } else {
          this.generalContent = {
            promoterNum: `您在商城累计消费金额仅差 <span style="color: #80cdd4;">${res
              .data.promoter_price || 0}元</span>即可开通推广权限`,
            title: "您未获得推广权限"
          };
        }

      });
    },
    /**
     * 关闭弹窗 
     */
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    },
    /**
     * 关闭弹窗 
     */
    closeMemberWindow(msg) {
      this.showWindow = msg;
    },
    /**
     * 数据列表
     * 5:新品上市 7:爆款推荐 8：精选特惠 9：限时抢购
     */
    getRecommendList() {
      let data = {
        page: 1,
        limit: 6
      }
      getGroomList(7, data).then(res => {
        this.RecommendList = res.data.list
      }).catch(err => {
        this.$dialog.error(err.msg)
      })
    },
    getNewProductList() {
      let data = {
        page: 1,
        limit: 6
      }
      getGroomList(5, data).then(res => {
        this.newProductList = res.data.list
      }).catch(err => {
        this.$dialog.error(err.msg)
      })
    },
    getFeaturedList() {
      let data = {
        page: 1,
        limit: 6
      }
      getGroomList(8, data).then(res => {
        this.featuredList = res.data.list
      }).catch(err => {
        this.$dialog.error(err.msg)
      })
    },
    getSeckillList() {
      let data = {
        page: 1,
        limit: 6
      }
      getGroomList(9, data).then(res => {
        this.seckillList = res.data.list
      }).catch(err => {
        this.$dialog.error(err.msg)
      })
    },
    /**
     * 获取首页banner
     */
    getHomeBanner() {
      getH5HomeBanner().then(res => {
        this.homeBanner = res.data
      }).catch(err => {
        this.$dialog.error(err.msg)
      })
    },
    /**
     * 跳转商品列表
     */
    goGoodsList(id) {
      this.$router.push({
        path: '/fitting_list',
        query: {
          id
        }
      })
    },
/**
     * 获取会员优惠券
     */
     getUseCoupons() {
      let that = this,
        type = 1;
        
        getCouponsUser(type).then(res => {
          that.couponsList = res.data;
        });
    } ,
    /**
     * 跳转搜索
     */
    goSearch() {
      console.log('000')
      this.$router.push({
        path: '/search'
      })
    },
    /**
     * 获取配件商品
     */
    getProducts() {
      let params = {
        page: 1,
        limit: 8,
        keyword: '',
        sid: 37,
        news: 0,
        priceOrder: '',
        salesOrder: ''
      }
      getProducts(params).then(res => {
        this.productList3 = res.data
      }).catch(err => {
        this.$dialog.error(err.msg);
      })
    },
    /**
     * 切换产品
     * @param {String} listName 列表名称
     * @param {Number} index 索引
     */
    handlerChange({ listName, index }) {
      this[listName] = this[listName].map(i => { i.checked = false; return i })
      this[listName][index].checked = true
    },
    setOpenShare: function () {
      let href = location.href;
      console.log(this.homeShareInfo.synopsis);
      getUserInfo().then(res => {
        if (isWeixin()) {
          href =
            href.indexOf("?") === -1
              ? href + "?spread=" + res.data.uid
              : href + "&spread=" + res.data.uid;
          let configAppMessage = {
            desc: this.homeShareInfo.synopsis,
            title: this.homeShareInfo.title,
            link: href,
            imgUrl: this.homeShareInfo.img
          };
          wechatEvevt(
            [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareAppMessage",
              "onMenuShareTimeline"
            ],
            configAppMessage
          )
        }
      }).catch()
    },

  }
};
</script>
<style>
[v-cloak] {
  display: none;
}


.index {
  background-color: #fff;
}

.index .follow {
  z-index: 100000;
}

.keep {
  text-align: center;
}

.search-wrap {
  position: fixed;
  left: 0;
  top: -1px;
  width: 100%;
  z-index: 100;
  /* padding: 0 .3rem;
  background: #000; */
}

.van-search__content {
  padding-left: 20px;
}

.search-wrap .van-search {
  padding: .16rem .3rem;
}

.search-wrap .van-cell {
  line-height: 1.4;
}

.van-field__body {
  height: 100%;
}

.search-wrap .van-field__control {
  font-size: .26rem;
  text-align: left;
}

.search-wrap .van-field__control::placeholder {
  color: #999 !important;
}

.search-wrap .van-icon-search {
  color: #303030;
}

.swipe-wrap .van-swipe__indicator.van-swipe__indicator--active {
  width: .55rem;
}

.swipe-wrap .van-swipe__indicator {
  border-radius: 4px;
  width: .15rem;
  height: .08rem;
  transition: all .3s;
}
</style>
<style scoped>
/* 追风者 */
.width92 {
  width: 92%;
  margin: 0 auto;
}

.swipe-wrap {
  padding: 0 .28rem .28rem .28rem;
}

/* 公用标题部分 */
.home-page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .42rem 0;
}

.home-page-title-left {
  display: flex;
}

.home-page-title .page-title {
  font-size: .38rem;
  color: #000;
}

.home-page-title .page-size {
  font-size: .26rem;
  display: flex;
  align-items: flex-end;
  padding-left: .18rem;
  color: #666;
  line-height: 1.2;
}

.home-page-title>p>a {
  font-size: .26rem;
  color: #666;
}

.home-top {
  background-image: url('../../assets/img/banner-bg.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: top;
  /* margin-top: 90px; */
}

/* 2 */
.shopping-info {
  display: flex;
  justify-content: space-between;
  padding: 0 .94rem;
}

.shopping-info-list {
  display: flex;
  align-items: center;
}

.shopping-info-img {
  display: flex;
  padding: 0 .1rem;
  justify-content: center;
  align-items: center;
}

.shopping-info-img>img {
  display: block;
  width: .28rem;
  height: .28rem;
}

.shopping-info-title {
  font-size: .24rem;
}

/* 3 */
.home-nav {
  display: flex;
  flex-wrap: wrap;
  padding-top: .3rem;
}

.home-nav-box {
  flex: 0 0 20%;
}

.home-nav-box-img {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home-nav-box-img>img {
  width: 1rem;
  height: 1rem;
}

.home-nav-box-title {
  font-size: .24rem;
  padding-top: .22rem;
  padding-bottom: .3rem;
  text-align: center;
}

/* 4 */
.home-card1 {
  display: flex;
  justify-content: space-between;
}

.home-card1-left {
  flex: 0 0 48%;
  position: relative;
}

.home-card1-right {
  flex: 0 0 48%;
  position: relative;
}

.home-card1-img {
  width: 100%;
  height: 2.2rem;
  border-radius: 10px;
  overflow: hidden;
}

.home-card1-img>img {
  width: 100%;
  height: 100%;
}

.home-card1-word {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: .4rem;
  padding-left: .3rem;
}

.home-card1-word>h4 {
  font-size: .3rem;
  color: #fff;
}

.home-card1-word>p {
  font-size: .2rem;
  color: #fff;
  padding-top: .14rem;
  padding-bottom: .2rem;
}

.home-card1-word>button {
  font-size: .2rem;
  padding: .1rem .2rem;
  background: #fff;
  color: #cbb695;
  border-radius: .2rem;
}

/* 5 */
.home-card2 img {
  width: 100%;
}

/* 6 */
.home-box6 .page-title {
  color: #fff;
}

.home-box6 .page-size {
  color: #fff;
}

.home-box6 .home-page-title {
  align-items: flex-end;
  padding: 0.3rem 0;
}

.home-box6 .home-page-title p>a {
  color: #fff;
  line-height: 1.2;
}

.home-box6 {
  /* a1c4fd c2e9fb */
  background: linear-gradient(to right, #9dccd0bd, #9dccd0);
}

.home-box6-bottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: .4rem;
}

.home-box6-card {
  background: #fff;
  border-radius: .1rem;
  overflow: hidden;
  flex: 0 0 48%;
  margin-bottom: 10px;
}

.home-box6-card-img {
  height: 3.3rem;
  width: 3.3rem;
}

.home-box6-card-img>img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.home-box6-card-info {
  padding: 0 0.05rem;
}

.home-box6-card-title {
  font-size: .28rem;
  padding-top: 0.15rem;
  text-align: center;
  color: #000;
}

.home-box6-card-num1 {
  font-size: .24rem;
  color: #999;
  padding-top: .05rem;
  text-decoration: line-through;
}

.home-box6-card-num2 {
  font-size: .3rem;
  color: #9dccd0;
  padding: .18rem 0;
}

/* 7 */
.home-box7-bom {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.home-box7-card {
  margin-bottom: .35rem;
  flex: 0 0 48.6%;
  box-shadow: 0.01rem 0.01rem 0.12rem #e6e6e6;
  border-radius: .1rem;
  overflow: hidden;
  background-color: #fff;
}

.home-box7-card-img {
  width: 3.35rem;
  height: 3.35rem;
  border-radius: .1rem;
  overflow: hidden;
  object-fit: cover;
}

.home-box7-card-img>img {
  width: 100%;
  height: 100%;
  border-radius: .1rem;
  object-fit: cover;
  overflow: hidden;
}

.home-box7-card .home-box7-card-info {
  padding: .3rem .2rem;
  background-color: #fff;
}

.home-box7-card .title {
  font-size: .28rem;
  color: #000;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  background-color: #fff;
}

.home-box7-card-info .num {
  font-size: .3rem;
  font-weight: bold;
  padding-top: .26rem;
  color: #9dccd0;
  background-color: #fff;
}

.home-box8-bom {
  display: flex;
}



.home-box8-card {

  flex-wrap: wrap;
  flex: 0 0 48.6%;
}

/* 8 */
.home-box8-card>a {
  background-color: #fff;
  margin-bottom: .26rem;
  display: flex;
}

.home-box8-card-img {
  width: 3.2rem;
  height: 3.2rem;
  border-radius: .1rem;
  overflow: hidden;
}

.home-box8-card-img>img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: .1rem;
  overflow: hidden;
}

.home-box8-card-info {
  flex: 1;
  padding-left: .26rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.home-box8-card-title {
  font-size: .28rem;
  padding-top: .36rem;
  line-height: 1.5;
  color: #000;
  width: 92%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.home-box8-card-num1 {
  width: 1.25rem;
  height: .42rem;
  background: #fcf1e9;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #faae7b;
  text-decoration: line-through;
  border-radius: .1rem;
  margin: .1rem 0;
}

.home-box8-card-num2 {
  font-size: 0.3rem;
  color: #9dccd0;
  font-weight: bold;
  margin: .3rem 0;
}

/* -------------------------------------------------------------------------------------------------------------------------- */
.category-list {
  display: flex;
  justify-content: center;
  align-content: center;
  margin: .3rem 0 .5rem;
}

.category-list .category-item {
  margin: 0 .5rem;
}

.category-list .image-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1rem;
  height: 1rem;
  border-radius: 5px;
  background: rgb(235, 235, 235, .6);
}

.category-list .image-wrap img {
  width: 50%;
}

.category-list .name {
  font-size: .28rem;
  color: #2d313d;
  line-height: 1;
  text-align: center;
  margin-top: .16rem;
}

.title-index {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.11rem;
  background: url(http://dreameshop.oss-cn-beijing.aliyuncs.com/10195202207291042162257.png) center / cover no-repeat
}

.title-index .title-index-wrap {
  width: 100%;
  text-align: center;
  line-height: 1;
}

.title-index .zh {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: .46rem;
  color: #2d313d;
  font-weight: 600;
}

.title-index .zh::before {
  display: block;
  content: '';
  width: .22rem;
  height: .0219rem;
  background: #141315;
  margin-right: .2rem;
}

.title-index .zh::after {
  display: block;
  content: '';
  width: .22rem;
  height: .0219rem;
  background: #141315;
  margin-left: .2rem;
}

.title-index .en {
  color: rgb(20, 19, 21, .5);
  font-size: .2rem;
  margin-top: .04rem;
}

.change-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  height: .95rem;
  font-size: .28rem;
  line-height: 1;
  color: rgb(45, 49, 61, .4);
}

.change-wrap .change-item-wrap {
  position: relative;
  width: 1.7rem;
  height: 100%;
  /* padding: .1rem .33rem; */
  /* width: 2.25rem; */
}

.change-wrap .change-item-wrap .change-item {
  position: absolute;
  left: 50%;
  top: 50%;
  white-space: nowrap;
  border-radius: 25px;
  width: 1.2rem;
  text-align: center;
  transform: translateX(-50%) translateY(-50%);
}

.change-wrap .change-item-wrap::after {
  position: absolute;
  display: block;
  content: '';
  width: 1px;
  height: .3rem;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: rgb(45, 49, 61, .2);
}

.change-wrap .change-item-wrap:last-of-type::after {
  display: none;
}

/* .change-wrap .change-item-wrap.on{
    padding: 0;
  } */
.change-wrap .change-item-wrap.on .change-item {
  padding: .1rem .15rem;
  color: rgb(45, 49, 61);
  border: 1px solid rgb(45, 49, 61);
}

.index-more {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  margin: .44rem 0 .62rem;
}

.index-more .text {
  font-size: .26rem;
  color: #2d313d;
}

.index-more .iconfont {
  font-size: .26rem;
  color: #2d313d;
}

.fitting {
  margin-top: .2rem;
}

.product-scroll {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* overflow-x: scroll; */
  margin-bottom: 0.2rem;
  padding: 0 20px;
}

.product-scroll .item {
  width: 3.2rem;
  line-height: 1;
  /* margin-left: .22rem;
  margin-right: .18rem; */
  background-color: #fff;
  box-shadow: .1rem .1rem .1rem #f1f1f1;
  border-radius: .1rem;
  margin-bottom: .3rem;
  /* margin-left: .3rem;
   margin-right: .3rem; */
}

/* .product-scroll .item:first-of-type {
  margin-left: .3rem;
}

.product-scroll .item:last-of-type {
  margin-right: .3rem;
} */

.product-scroll .img {
  width: 3.2rem;
  height: 3.2rem;
  border-radius: .1rem;
  overflow: hidden;
}

.product-scroll .img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-scroll .title {
  font-size: .28rem;
  color: #565656;
  text-align: center;
  margin-top: .24rem;
  padding: 0 .2rem;
}

.product-scroll .price {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin: .26rem 0;
}

.product-scroll .price .name {
  font-size: .18rem;
  color: #000;
  padding-bottom: 2px;
}

.product-scroll .price .num {
  font-size: .3rem;
  font-weight: bold;
  color: #9dccd0;
}

.product-scroll .btn {
  display: flex;
  width: 65%;
  padding: 0 .2rem;
  border-radius: .06rem;
  margin: .2rem auto;
  height: .54rem;
  line-height: .54rem;
  background: linear-gradient(to right, #9dccd0, #9dccd0);
  color: #fff;
  justify-content: space-evenly;
  align-items: center;
}

.product-scroll .btn .p1 {
  font-size: .26rem;
  align-self: center;
}

.product-scroll .btn .p2 {
  font-size: .26rem;
  align-self: flex-end;
}

/* .fitting-more{
    margin-top: 0;
  } */
.advertise img {
  width: 100%;
}

.bottom-safe {
  height: 1.2rem;
}

.home-box8-bom {
  /* padding: 10px; */
}
</style>
